import { Dialog, IconHelp } from "@dream/ui";

/** Atalhos do chrome Ofative, em português. */

export function HelpDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange} title="Atalhos e ajuda" size="sm">
      <div className="space-y-3 text-[14px] text-[var(--color-ink-secondary)]">
        <p className="flex items-start gap-2">
          <IconHelp className="mt-0.5 size-4 shrink-0 text-[#0074FF]" />O calendário operacional da
          Dream Vision. Entregas, clientes, o postador nas 34 redes e o Moon (Deck Figma ou PDF:
          classifica cronograma da semana vs roadmap, extrai cada postagem e agenda). O cliente
          entra no calendário dele em /@handle.
        </p>
        <ul className="space-y-2">
          <Shortcut keys="⌘K" label="Abrir a paleta de comando" />
          <Shortcut keys="⌘B" label="Recolher ou expandir o menu" />
          <Shortcut keys="N" label="Nova entrega" />
          <Shortcut keys="G depois S" label="Ir para configurações" />
          <Shortcut keys="Esc" label="Fechar janelas e menus" />
        </ul>
      </div>
    </Dialog>
  );
}

function Shortcut({ keys, label }: { keys: string; label: string }) {
  return (
    <li className="flex items-center justify-between gap-3">
      <span>{label}</span>
      <kbd className="rounded-md border border-[var(--color-line)] bg-[var(--color-surface-subtle)] px-1.5 py-0.5 text-[11px] font-semibold text-[var(--color-ink)]">
        {keys}
      </kbd>
    </li>
  );
}
